import { createContext } from "react";

import { SelectionSiteStatus } from "../../../../generated/api";

const SelectionSiteStatusContext = createContext<SelectionSiteStatus>(SelectionSiteStatus.Draft);

export default SelectionSiteStatusContext;
